import { createGenericStore } from '@/stores/utils/genericStore.js'
import axios from 'axios'

const businessSystemAssetStoreOptions = {
  actions: {
    async fetchItemsForBusinessSystem(businessSystemId) {
      const normalizedBusinessSystemId = Number(businessSystemId)

      if (!Number.isInteger(normalizedBusinessSystemId) || normalizedBusinessSystemId <= 0) {
        this.items = []
        return []
      }

      this.isLoading = true
      this.error = null

      try {
        const { data } = await axios.get(`/api/v1/business-systems/${normalizedBusinessSystemId}/assets`)
        this.items = Array.isArray(data) ? data : []

        return this.items
      } catch (err) {
        this.error = err
        console.error(`Error fetching assets for business system ${normalizedBusinessSystemId}:`, err)
        throw err
      } finally {
        this.isLoading = false
      }
    },
    async deleteBusinessSystemAsset(businessSystemId, businessSystemAssetId) {
      const normalizedBusinessSystemId = Number(businessSystemId)
      const normalizedAssetId = Number(businessSystemAssetId)

      this.isLoadingItems.push(normalizedAssetId)
      this.error = null

      try {
        await axios.delete(`/api/v1/business-systems/${normalizedBusinessSystemId}/assets/${normalizedAssetId}`)
        this.itemRemoveFromState(normalizedAssetId)
      } catch (err) {
        this.error = err
        console.error(`Error deleting business system asset ${normalizedAssetId}:`, err)
        throw err
      } finally {
        this.isLoadingItems = this.isLoadingItems.filter((loadingItemId) => loadingItemId !== normalizedAssetId)
      }
    },
  },
}

export const useBusinessSystemAssetStore = createGenericStore(
  'businessSystemAsset',
  '/api/v1/business-systems',
  businessSystemAssetStoreOptions
)
